<!-- PAGE TITLE
        ================================================== -->
<section class="page-title-section bg-img cover-background top-position1 left-overlay-dark" data-overlay-dark="9"
         data-background="img/bg/bg-04.jpg"
         style="background-image: url(assets/img/bg/bg-04.jpg);">
    <div class="container">
        <div class="row text-center">
            <div class="col-md-12">
                <h1>EXTRACURRICULAR ACTIVITIES</h1>
            </div>
            <div class="col-md-12">
                <ul>
                    <li><a routerLink="/">Home</a></li>
                    <li><a href="#!">Extracurricular Activities</a></li>
                </ul>
            </div>
        </div>
    </div>
</section>

<!-- EXTRA
      ================================================== -->
<section class="py-0">
    <div class="container">
        <div class="section-heading">
            <span class="sub-title">Activities</span>
            <h2 class="h1 mb-0">Extracurricular Activities</h2>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 order-2 order-lg-1">
                <div class="instructor-partner-content h-100 bg-secondary">
                    <h2 class="text-white h1 mb-3">National Webinar on NEP</h2>
                    <p class="text-white">National Webinar on National Education Policy 2020 was organized on Feb 25,
                        2021 under the Institutionâ€™s Innovation Council (Ministry of HRD) by Prof. Kamlesh Misra, Vice
                        Chancellor, Rishihood University, Sonepat.</p>
                </div>
            </div>
            <div class="col-lg-6 bg-img cover-background min-height order-1 order-lg-2"
                 data-background="img/content/about-04.jpg"
                 style="background-image: url(assets/img/curricular/1.jpeg);">
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 bg-img cover-background min-height" data-background="img/content/about-05.jpg"
                 style="background-image: url(assets/img/curricular/2.jpeg);background-size: cover;">
            </div>
            <div class="col-lg-6">
                <div class="instructor-content h-100 bg-primary">
                    <h2 class="h1 mb-3 text-white">Faculty Development Program</h2>
                    <p class="text-white">A Faculty Development Program on â€˜Teaching Learning Processâ€™ was organized
                        by Arni University on May 22-23rd 2021 to train teachers, trainees and researchers for
                        developing Teaching Competencies.</p>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 order-2 order-lg-1">
                <div class="instructor-partner-content h-100 bg-secondary">
                    <h2 class="text-white h1 mb-3">How to File a Patent</h2>
                    <p class="text-white">National Webinar on â€˜How to File a Patentâ€™ was organized by Arni
                        University on May 29, 2021 and the session was delivered by Prof. Ramesh Chandra Panda (Dean,
                        Research & Development Cell, Synergy Institute of Engg. & Technology, Dhenkanal, Odisha).</p>
                </div>
            </div>
            <div class="col-lg-6 bg-img cover-background min-height order-1 order-lg-2"
                 data-background="img/content/about-04.jpg"
                 style="background-image: url(assets/img/curricular/3.jpeg);">
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 bg-img cover-background min-height" data-background="img/content/about-05.jpg"
                 style="background-image: url(assets/img/curricular/4.jpeg);">
            </div>
            <div class="col-lg-6">
                <div class="instructor-content h-100 bg-primary">
                    <h2 class="h1 mb-3 text-white">10 steps Strategy to Grow Business</h2>
                    <p class="text-white">A Webinar on â€œ10 steps Strategy to Grow Businessâ€ was organized by Arni
                        University on June 10, 2021 for students as aspiring Entrepreneurs, Professionals and
                        Businessmen. The session was delivered by Mr. Pankaj Dudhaiya (Founder and CEO, 51K Growth
                        Hub).</p>
                </div>
            </div>
        </div>
        <div class="row g-0">
            <div class="col-lg-6 order-2 order-lg-1">
                <div class="instructor-partner-content h-100 bg-secondary">
                    <h2 class="text-white h1 mb-3">Talent Hunt Competition- â€˜UMANG-2021â€™</h2>
                    <p class="text-white">One Day Virtual Cultural Fest cum Talent Hunt Competition- â€˜UMANG-2021â€™
                        was organized by Arni University on June 28th, 2021 for motivating students from the campus and
                        outside.</p>
                </div>
            </div>
            <div class="col-lg-6 bg-img cover-background min-height order-1 order-lg-2"
                 data-background="img/content/about-04.jpg"
                 style="background-image: url(assets/img/curricular/5.jpeg);">
            </div>
        </div>
    </div>
</section>
